import { Col, InputNumber, Row, Space, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { DownloadOutlined, PrinterOutlined } from "@ant-design/icons";
import { ModalItem, ButtonItem } from "../../../../Components/Items";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import etiquetasMovimientoInventarioPdf from "../../../../Pdf/etiquetasMovimientoInventarioPdf";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

class ModalEtiquetaLoteInsumo extends Component {
  state = {
    loading: false,
    insumo: null,
    empresa: null,
    conDatosEmpresa: true,
    copias: 1,
    pdf: null,
    regenTimer: null,
  };

  componentWillUnmount() {
    if (this.state.regenTimer) clearTimeout(this.state.regenTimer);
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible) {
      this.setState(
        { conDatosEmpresa: true, copias: 1, insumo: null, empresa: null },
        () => this.consultarDatos()
      );
    }
  }

  consultarDatos() {
    this.setState({ loading: true });
    axios
      .post(
        "insumos/datosEtiquetaInsumoPdf",
        {
          insumoId: this.props.insumoId,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState(
            { insumo: res.data.insumo, empresa: res.data.empresa, loading: false },
            () => this.generarPdf(this.state.conDatosEmpresa)
          );
        } else {
          message.error("No se encontraron datos del insumo");
          this.setState({ loading: false });
        }
      })
      .catch(() => {
        message.error("Error al generar el documento");
        this.setState({ loading: false });
      });
  }

  generarPdf(conDatosEmpresa) {
    const { insumo, empresa, copias } = this.state;
    if (!insumo || !empresa) return;

    const datos = {
      empresa,
      movimiento: {
        insumos: Array.from({ length: copias }, () => ({ insumo })),
      },
    };

    etiquetasMovimientoInventarioPdf(datos, { conDatosEmpresa }).then((dd) => {
      const pdf = pdfMake.createPdf(dd);
      this.setState({ pdf }, () => {
        pdf.open({}, window.frames["EtiquetaLoteInsumoIframe"]);
      });
    });
  }

  cambiarOpcion(conDatosEmpresa) {
    if (conDatosEmpresa === this.state.conDatosEmpresa) return;
    this.setState({ conDatosEmpresa }, () => this.generarPdf(conDatosEmpresa));
  }

  onChangeCopias = (val) => {
    const n = Math.max(1, Number(val) || 1);
    this.setState({ copias: n });
    if (this.state.regenTimer) clearTimeout(this.state.regenTimer);
    const regenTimer = setTimeout(
      () => this.generarPdf(this.state.conDatosEmpresa),
      250
    );
    this.setState({ regenTimer });
  };

  descargarPdf() {
    if (this.state.pdf) {
      const clave = this.state.insumo?.clave || this.state.insumo?.codigo || "Insumo";
      this.state.pdf.download(`Etiqueta_${clave}.pdf`);
    }
  }

  imprimir = () => {
    if (!this.state.pdf) return;
    this.state.pdf.print();
  };

  handleCancel = () => {
    this.props.cerrarModal?.();
  };

  render() {
    const { conDatosEmpresa, copias } = this.state;
    return (
      <ModalItem
        title="Etiqueta de Lote"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.handleCancel}
        paddingTop
        width={900}
        footer={null}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 8,
            marginBottom: 10,
          }}
        >
          <Space wrap>
            <ButtonItem
              type={conDatosEmpresa ? "primary" : "default"}
              cyan={conDatosEmpresa}
              blanco={!conDatosEmpresa}
              icon={<PrinterOutlined />}
              onClick={() => this.cambiarOpcion(true)}
            >
              Con datos de empresa
            </ButtonItem>
            <ButtonItem
              type={!conDatosEmpresa ? "primary" : "default"}
              cyan={!conDatosEmpresa}
              blanco={conDatosEmpresa}
              icon={<PrinterOutlined />}
              onClick={() => this.cambiarOpcion(false)}
            >
              Sin datos de empresa
            </ButtonItem>
            <Row align="middle" gutter={4}>
              <Col>
                <label style={{ fontWeight: 600 }}>Copias</label>
              </Col>
              <Col>
                <InputNumber
                  min={1}
                  max={100}
                  value={copias}
                  onChange={this.onChangeCopias}
                  style={{ width: 70 }}
                />
              </Col>
            </Row>
          </Space>
          <Space>
            <ButtonItem
              icon={<PrinterOutlined />}
              type="primary"
              onClick={this.imprimir}
            >
              Imprimir
            </ButtonItem>
            <ButtonItem
              icon={<DownloadOutlined />}
              type="primary"
              onClick={() => this.descargarPdf()}
            >
              Descargar PDF
            </ButtonItem>
            <ButtonItem danger onClick={this.handleCancel}>
              Cerrar
            </ButtonItem>
          </Space>
        </div>

        <iframe
          title="Etiqueta Lote Insumo"
          style={{ width: "100%", height: "75vh", border: "1px solid #d9d9d9" }}
          id="EtiquetaLoteInsumoIframe"
          name="EtiquetaLoteInsumoIframe"
        />
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalEtiquetaLoteInsumo);
